

























import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosMarca extends Vue {

    public created () {
        this.$store.dispatch("LOAD_MARCAS").then();
    }

    get loadingMarcas () {
        return this.$store.state.loading_marcas;
    }

    get listaMarcas () {
        return this.$store.state.marcas;
    }

    get marca () {
        return this.$store.state.cotacao.marca;
    }

    set marca ( value ) {
        this.$store.dispatch("SET_MARCA", value).then();
    }

    get errorMarca () {
        return this.$store.state.errors.marca;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }

    public getLogoMarca ( value: string ) {
        try {
            return require("@/assets/marcas/" + value + ".svg");
        } catch (e) {
            return require("@/assets/marcas/Desconhecida.svg");
        }
    }
}
